import axios from "axios";

const baseURL = process.env.REACT_APP_BASE_URL;

// Create axios instance
const api = axios.create({
  baseURL: baseURL,
  // baseURL: "http://localhost:8080/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor - adds auth token
api.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.Language = window.selectedLanguage || "en";
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Response interceptor - handles 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear all session data
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("customerId");
      // Add any other session items to clear

      // Redirect to login page
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Helper function to convert fetch-style calls to axios
export const apiFetch = async (endpoint, options = {}) => {
  const {
    method = 'GET',
    body,
    signal,
    headers = {},
    ...restOptions
  } = options;

  try {
    const config = {
      method: method.toLowerCase(),
      url: endpoint,
      signal,
      headers: {
        ...headers,
      },
      ...restOptions,
    };

    if (body) {
      config.data = typeof body === 'string' ? JSON.parse(body) : body;
    }

    const response = await api.request(config);

    // Return in fetch-like format for easier migration
    return {
      ok: true,
      status: response.status,
      json: async () => response.data,
      data: response.data, // Direct access for axios users
    };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      json: async () => error.response?.data || { error: error.message },
      data: error.response?.data,
    };
  }
};

// Helper for file downloads with authentication
export const downloadFile = async (endpoint, filename, payload = null) => {
  try {
    const config = {
      responseType: 'blob',
    };

    const response = payload
      ? await api.post(endpoint, payload, config)
      : await api.get(endpoint, config);

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    console.error('Download failed:', error);
    return { success: false, error: error.message };
  }
};

export default api;